<template>
  <div class="content">
    <el-form
      class="form"
      :model="ruleForm"
      ref="form"
      label-width="110px"
      label-position="right"
      :rules="rules"
      :disabled="formDisabled"
    >
      <el-form-item label="项目名称" prop="projectName">
        <el-input placeholder="请填写项目名称" v-model="ruleForm.projectName"></el-input>
      </el-form-item>
      <el-form-item label="项目来源" prop="projectSource">
        <el-select v-model="ruleForm.projectSource" clearable placeholder="请选择项目来源">
          <el-option
            v-for="item in sourceOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业资质" prop="projectType">
        <el-select v-model="ruleForm.projectType" clearable placeholder="请选择企业资质">
          <el-option
            v-for="item in projectTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="单位名称" prop="unitName">
        <el-input placeholder="请填写单位名称" v-model="ruleForm.unitName"></el-input>
        <!-- <el-select v-model="ruleForm.region" clearable placeholder="请选择所属地区">
          <el-option
            v-for="item in areaOptions"
            :key="item.value"
            :label="item.label"
            :value="item.label"
          ></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="所属年度" prop="year">
        <el-date-picker
          v-model="ruleForm.year"
          type="year"
          format="yyyy"
          value-format="yyyy"
          placeholder="选择年度"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="发布时间" prop="publishedTime">
        <el-date-picker
          v-model="ruleForm.publishedTime"
          type="date"
          placeholder="选择发布时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="项目简介">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请输入内容"
          v-model="ruleForm.introduction"
        ></el-input>
      </el-form-item>
      <el-form-item label="发布" prop="publishedFlag">
        <el-switch v-model="ruleForm.publishedFlag" active-text="是" inactive-text="否"></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">

export default {
  props: ['formDisabled', 'messageId'],
  components: {},
  data() {
    return{
      projectTypeOptions: [
        { value: "4", label: "中小微企业" },
        { value: "2", label: "科技型中小企业" },
        { value: "1", label: "高新技术企业" },
        { value: "5", label: "专精特新企业" },
        { value: "6", label: "专精特新“小巨人”企业" },
        { value: "7", label: "高校院所" },
      ],
      sourceOptions: [
				{
					value: "4",
					label: "省级计划项目",
				},
				{
					value: "5",
					label: "市级计划项目",
				},
				{
					value: "6",
					label: "融资路演项目",
				}
			],
      areaOptions: [{
					value: "1",
					label: "兰州市",
				},{
					value: "2",
					label: "嘉峪关市",
				},{
					value: "3",
					label: "金昌市",
				},{
					value: "4",
					label: "白银市",
				},{
					value: "5",
					label: "天水市",
				},{
					value: "6",
					label: "武威市",
				},{
					value: "7",
					label: "张掖市",
				},{
					value: "8",
					label: "酒泉市",
				},{
					value: "9",
					label: "平凉市",
				},{
					value: "10",
					label: "庆阳市",
				},{
					value: "11",
					label: "定西市",
				},{
					value: "12",
					label: "陇南市",
				},{
					value: "13",
					label: "临夏回族自治州",
				},{
					value: "14",
					label: "甘南藏族自治州",
				},],
      ruleForm: {
        introduction:'', // 项目简介
        dataSrc: 1, // 数据来源：1页面录入, 2Excel导入
        projectName: null, // 项目名称
        projectSource: null, // 项目来源：4省级计划项目，5市级计划项目，6融资路演项目
        projectType: null, // 企业资质，允许为空
        unitName: null, // 单位名称
        region: null, // 所属地区
        year: null, // 所属年度
        publishedTime: null, // 发布时间
        publishedFlag: false // 是否发布
      },
      rules: {
        projectName: [{
					required: true,
					message: "请填写项目名称",
					trigger: "blur"
				}],
				projectSource: [{
					required: true,
					message: "请选择项目来源",
					trigger: "change"
				}],
        // region: [{
				// 	required: true,
				// 	message: "请选择所属地区",
				// 	trigger: "change"
				// }],
        year: [{
					required: true,
					message: "请选择所属年度",
					trigger: "change"
				}],
        publishedTime: [{
					required: true,
					message: "请选择发布时间",
					trigger: "change"
				}]
      },
    }
  },
  methods: {
    parentHandleclick(e) {
      this.$refs.form.validate((val) => {
        if (val) {
          const params = {
            ...this.ruleForm,
            publishedFlag: this.ruleForm.publishedFlag ? 1 : 0
          }
          e && e(params);
        }
      });
    },
    initDate(id) {
      this.http.get(`${this.urlConfig.devUrl}apij2/admin-api/finance/projects/get?id=${id}`)
        .then((res) => {
          if (res.code == 0) {
            this.ruleForm = {
              ...res.data
            }
            this.ruleForm.publishedFlag = Boolean(res.data.publishedFlag);
            this.ruleForm.year = res.data.year + '';
            this.ruleForm.projectSource = res.data.projectSource == null
              ? null
              : String(res.data.projectSource);
            this.ruleForm.projectType = res.data.projectType == null
              ? null
              : String(res.data.projectType);
          } else {
            this.$message({
              message: "失败！",
              type: "error",
            });
          }
        });
    },
  },
  created() {
    if(this.messageId) {
      this.initDate(this.messageId)
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  /deep/ {
    .el-input,
    .el-select {
      width: 100%;
    }
  }
}
</style>
